export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/request-headers/getters.js